import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isUserAllowedToChangeSettings, OcpsPolicyFeature } from 'owa-owsprime-policies-store';

export default function isUserAllowedToChangeNotificationSettings(): boolean {
    return (
        !isGlobalFeatureEnabled('policy-notificationPolicies') ||
        isUserAllowedToChangeSettings(
            OcpsPolicyFeature.Notifications,
            getGlobalSettingsAccountMailboxInfo()
        )
    );
}
